export default __webpack_public_path__ + "static/media/DesktopView.3f6bb8c5.png";